import React from "react";

import OfferingStatusBadge from "./OfferingStatusBadge";
import OfferingTypeBadge from "./OfferingTypeBadge";

const OfferingTable = ({
  offerings = [],
  loading = false,
  onView,
  onEdit,
  onDelete,
}) => {
  if (loading) {
    return (
      <div className="offering-table-state">
        Loading offerings...
      </div>
    );
  }

  if (!offerings.length) {
    return (
      <div className="offering-table-state">
        No offerings found.
      </div>
    );
  }

  return (
    <div className="offering-table-wrapper">
      <table className="offering-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Type</th>
            <th>Status</th>
            <th>Order</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {offerings.map((offering) => (
            <tr key={offering.id}>
              <td>
                <div className="offering-table-name">
                  <strong>{offering.name}</strong>

                  {offering.short_description && (
                    <small>
                      {offering.short_description}
                    </small>
                  )}
                </div>
              </td>

              <td>
                {offering.category_name || "-"}
              </td>

              <td>
                <OfferingTypeBadge
                  type={offering.type}
                />
              </td>

              <td>
                <OfferingStatusBadge
                  isActive={offering.is_active}
                />
              </td>

              <td>
                {offering.display_order ?? 0}
              </td>

              <td>
                {offering.created_at
                  ? new Date(
                      offering.created_at
                    ).toLocaleDateString()
                  : "-"}
              </td>

              <td>
                <div className="offering-table-actions">
                  <button
                    type="button"
                    onClick={() =>
                      onView?.(offering)
                    }
                  >
                    View
                  </button>

                  <button
                    type="button"
                    onClick={() =>
                      onEdit?.(offering)
                    }
                  >
                    Edit
                  </button>

                  <button
                    type="button"
                    className="danger"
                    onClick={() =>
                      onDelete?.(offering)
                    }
                  >
                    Delete
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OfferingTable;